/**
 * Shared Tailwind grid-column templates for the cardio set rows.
 * Lives in its own module so SetRow (the row) and ExerciseRow (the header)
 * stay in lockstep — and so the literal `grid-cols-[...]` strings are
 * statically present for Tailwind's JIT scanner. Keyed by the number of
 * cardio metric columns after the MIN column (0, 1, or 2).
 */
// { [nMetrics]: { on: <rpe-enabled grid>, off: <rpe-disabled grid> } }
export const CARDIO_ROW_GRID = {
  0: { on: 'grid-cols-[44px_60px_1fr_48px_36px]',          off: 'grid-cols-[44px_60px_1fr_36px]' },
  1: { on: 'grid-cols-[44px_60px_1fr_1fr_48px_36px]',      off: 'grid-cols-[44px_60px_1fr_1fr_36px]' },
  2: { on: 'grid-cols-[44px_60px_1fr_1fr_1fr_48px_36px]',  off: 'grid-cols-[44px_60px_1fr_1fr_1fr_36px]' },
};

/** Resolve the grid class for `nMetrics` metric columns. Falls back to 0. */
export function cardioGridClass(nMetrics, rpeEnabled) {
  return (CARDIO_ROW_GRID[nMetrics] || CARDIO_ROW_GRID[0])[rpeEnabled ? 'on' : 'off'];
}
